import timezone from "moment-timezone";
import CurrencyHelpers from "lib/helpers/CurrencyHelpers";
import getFirstParagraph from "./getFirstParagraph";
//METHODS
import getRealEstateTermsHTML from "./getRealEstateTermsHTML";
import getEventTermsHTML from "./getEventTermsHTML";

const TextEditorHelpers = {
  getRealEstateTermsHTML,
  getEventTermsHTML
};

//------------------------------------------------------------------------------
// CONSTANTS FOR PORTRAIT, NEWBORN:
//------------------------------------------------------------------------------
const retainerAndPaymentPortrait = ({
  depositAmount,
  dueDate,
  currencySymbol
}) => `
  <h3>RETAINER & PAYMENT:</h3>
  <p>
    The Client shall make a non-refundable retainer in the amount of ${CurrencyHelpers.centsToDollars(
      depositAmount,
      { symbol: currencySymbol }
    )}
    for the Photographer to perform the services specified herein. Upon payment,
    the Photographer will reserve the time and date agreed upon by both parties.
    The Client agrees that this retainer is earned by the Photographer when paid, and is
    remitted in consideration of the experience, reputation, skill of the Photographer, and in
    consideration of the inability of the Photographer to schedule other clients during this time.
    Remaining balance shall be made no later than ${dueDate}.
    This deposit is a non-refundable retainer, should the Client cancel the session.
    It is transferable to another date, provided that notice of 7 days is given to the Photographer.
  </p>
`;
//------------------------------------------------------------------------------
const cooperationPortrait = () => `
  <h3>COOPERATION:</h3>
  <p>
    The Client shall assist and cooperate with the Photographer in obtaining the desired photographs,
    including but not limited to specifying persons and/or scenes to be photographed;
    taking time to pose for photographs at the Photographer’s direction;
    pre-shoot consultations; etc. Photographer shall not be responsible for photographs not
    taken as a result of Client’s failure to provide reasonable assistance or cooperation.
  </p>
`;
//------------------------------------------------------------------------------
const imageUseAndCopyrightPortrait = ({ organization }) => `
  <h3>IMAGE USE & COPYRIGHTS:</h3>
  <p>
    The photographs produced by ${
      organization.title
    } are protected by Federal Copyright Law and may
    not be reproduced in any manner without ${
      organization.title
    }'s explicitly written permission.
    The photographer retains copyright to the photographs, and hereby grants the Client unlimited
    but non-exclusive rights to use or reproduce the photographs for which the client pays,
    for personal use only. A print release will be provided to the Client, with which the Client
    may make prints for personal use and sharing, as well as use for their personal blogs and
    social networks. Photographs shall be delivered to the Client via digital download.
    The Client is prohibited from further editing of images in any form. The Client is
    also prohibited from using photos in contests without written consent from ${
      organization.title
    }.
    Client may not, for any reason, sell their images to any third party.
  </p>
`;
//------------------------------------------------------------------------------
const imageDeliveryPortrait = ({ organization }) => `
  <h3>IMAGE DELIVERY:</h3>
  <p>
    Digital files are given as full-resolution JPEG files, via a private online gallery.
    The files come with a print release, and are recommended to be printed through ${
      organization.title
    }’s
    chosen lab via the Client's gallery. Photos, albums and wall art purchased through ${
      organization.title
    }
     are 100% guaranteed for accuracy and quality. If the Client chooses to print through any labs
     other than through the photographer, ${
       organization.title
     } holds no responsibility for the
     quality of the photographs produced.
  </p>
`;
//------------------------------------------------------------------------------
const modelReleasePortrait = ({ organization }) => `
  <h3>MODEL RELEASE:</h3>
  <p>
    The Client & Subject hereby grant to ${
      organization.title
    } and its legal representatives and assigns,
    the irrevocable and unrestricted right to use and publish photographs of the Client or in
    which the Client may be included, for editorial, trade, advertising and any other purpose
    and in any manner and medium; to alter the same; and to copyright the same. The Client hereby
    releases ${
      organization.title
    } and its legal representatives and assigns from all claims and liability
    relating to said photographs.
  </p>
`;
//------------------------------------------------------------------------------
const limitOfLiabilityPortrait = () => `
  <h3>LIMIT OF LIABILITY:</h3>
  <p>
    In the unlikely event that the Photographer is injured or becomes too ill, or has an extreme
    emergency that prevents him or her from photographing the event, the Photographer will make
    every effort to reschedule the event. If for whatever reason this is not possible, responsibility
    and liability is limited to the return of all payments received for the package or session purchased.
  </p>
`;
//------------------------------------------------------------------------------
const shootingTimePortrait = () => `
  <h3>SHOOTING TIME:</h3>
  <p>
    The Client agrees that cooperation and punctuality are essential to accomplish the
    goals and wishes of all parties. Shooting time commences at the scheduled start time.
    Any Client that is late arriving to the photography session will have the amount of
    time late deducted from the time allotted for the session. Clients shall not be
    compensated for the time deducted from the event due to late arrival of the Client.
  </p>
`;
//------------------------------------------------------------------------------
const locationPermitsAndFeesPortrait = () => `
  <h3>LOCATION PERMITS & FEES:</h3>
  <p>
    Clients are responsible for any applicable location fees and permits, as well as any
    location expenses such as parking or admittance fees. If there are any costs/fees associated
    with the session location, you, the client, will be responsible for all fees for both
    Client & Photographer.
  </p>
`;
//------------------------------------------------------------------------------
const reschedulingPortrait = () => `
  <h3>RESCHEDULING:</h3>
  <p>
    If an illness or situation prevents a photo session from taking place, client
    may reschedule their session at least 48 hours prior to their shoot without penalty.
    Should client fail to give 48 hours notice, or decide to completely cancel the shoot,
    the non-refundable deposit is forfeited and will not be refunded. Photographer reserves
    the right to reschedule due to illness, weather, equipment malfunction, or other circumstances
    beyond their control.
  </p>
`;
//------------------------------------------------------------------------------
const jurisdictionPortrait = ({ organization }) => {
  console.log("jurisdictionPortrait");
  console.log(organization);
  return `
  <h3>JURISDICTION:</h3>
  <p>
    The state and federal courts serving ${organization.city ||
      "COUNTY/CITY"}, ${organization.state ||
    "STATE"} shall have exclusive jurisdiction over
    disputes arising from this Agreement, and both parties hereto consent to the jurisdiction of such courts.
  </p>
`;
};
//------------------------------------------------------------------------------
const preparationPortrait = () => `
  <h3>PREPARATION:</h3>
  <p>
    The Client shall feed the baby a full feeding right before the session and shall keep
    the baby awake for one or more hours before the session. Baby shall be fed immediately at the beginning
    of the session or just prior to arrival. The baby must be dressed in loose fitting clothing for ease
    of changes for portraits. The Client shall bring at least two bottles for feeding or supplies for
    nursing. If a pacifier or soother is required, the Client shall supply those items.
  </p>
`;
//------------------------------------------------------------------------------
const subjectsPortrait = () => `
  <h3>SUBJECTS:</h3>
  <p>
    The Client shall maintain control of other subjects including siblings. It is the responsibility
    of the Client to ensure the cooperation of additional subjects as not to intrude on the baby’s
    immediate area. The Client shall provide all necessary controls over additional subjects.
  </p>
`;
//------------------------------------------------------------------------------
const wardrobeAndStylingPortrait = () => `
  <h3>WARDROBE AND STYLING:</h3>
  <p>
    The client is responsible for choices in wardrobe, makeup, and hairstyle. No reshoots
    are available due to client disliking the wardrobe or styling in photos.
  </p>
`;
//------------------------------------------------------------------------------
const typeOfModelReleasePortrait = ({ organization }) => `
  <h3>TYPE OF MODEL RELEASE:</h3>
  <p>
    ${
      organization.title
    } understands that boudoir photography is very personal and respects
    your privacy. Because of this please select the appropriate box regarding privacy
    & usage.
  </p>
`;
//------------------------------------------------------------------------------
// TEMPLATES
//------------------------------------------------------------------------------
TextEditorHelpers.getPortraitTermsHTML = options => {
  const TIMEZONE = timezone.tz.guess() || "America/New_York"; // guess users time zone
  const firstParagraph = getFirstParagraph(options);
  console.log(
    "******=========*********> TextEditorHelpers.getPortraitTermsHTML"
  );
  console.log(options);
  const {
    finalPaymentDueDate,
    depositAmount,
    currencySymbol,
    organization
  } = options;
  const dueDate = finalPaymentDueDate
    ? timezone(finalPaymentDueDate)
        .tz(TIMEZONE)
        .format("dddd, MMMM D YYYY")
    : "";

  return `
    <div>
      ${firstParagraph}
      ${retainerAndPaymentPortrait({ depositAmount, dueDate, currencySymbol })}
      ${cooperationPortrait()}
      ${imageUseAndCopyrightPortrait({ organization })}
      ${imageDeliveryPortrait({ organization })}
      ${modelReleasePortrait({ organization })}
      ${limitOfLiabilityPortrait()}
      ${shootingTimePortrait()}
      ${locationPermitsAndFeesPortrait()}
      ${reschedulingPortrait()}
      ${jurisdictionPortrait({ organization })}
    </div>
  `;
};
//------------------------------------------------------------------------------
TextEditorHelpers.getNewbornTermsHTML = options => {
  const TIMEZONE = timezone.tz.guess() || "America/New_York"; // guess users time zone
  const firstParagraph = getFirstParagraph(options);
  const {
    finalPaymentDueDate,
    depositAmount,
    organization,
    currencySymbol
  } = options;
  const dueDate = finalPaymentDueDate
    ? timezone(finalPaymentDueDate)
        .tz(TIMEZONE)
        .format("dddd, MMMM D YYYY")
    : "";

  return `
    <div>
      ${firstParagraph}
      ${retainerAndPaymentPortrait({ depositAmount, dueDate, currencySymbol })}
      ${cooperationPortrait()}
      ${imageUseAndCopyrightPortrait({ organization })}
      ${imageDeliveryPortrait({ organization })}
      ${modelReleasePortrait({ organization })}
      ${limitOfLiabilityPortrait()}
      ${shootingTimePortrait()}
      ${locationPermitsAndFeesPortrait()}
      ${reschedulingPortrait()}
      ${preparationPortrait()}
      ${subjectsPortrait()}
    </div>
    `;
};
//------------------------------------------------------------------------------
TextEditorHelpers.getBoudoirTermsHTML = options => {
  const TIMEZONE = timezone.tz.guess() || "America/New_York"; // guess users time zone
  const firstParagraph = getFirstParagraph(options);
  const { finalPaymentDueDate, depositAmount, organization } = options;
  const dueDate = finalPaymentDueDate
    ? timezone(finalPaymentDueDate)
        .tz(TIMEZONE)
        .format("dddd, MMMM D YYYY")
    : "";

  return `
    <div>
      ${firstParagraph}
      ${retainerAndPaymentPortrait({ depositAmount, dueDate })}
      ${cooperationPortrait()}
      ${imageUseAndCopyrightPortrait({ organization })}
      ${imageDeliveryPortrait({ organization })}
      ${modelReleasePortrait({ organization })}
      ${limitOfLiabilityPortrait()}
      ${shootingTimePortrait()}
      ${locationPermitsAndFeesPortrait()}
      ${reschedulingPortrait()}
      ${wardrobeAndStylingPortrait()}
      ${typeOfModelReleasePortrait({ organization })}
    </div>
    `;
};
//------------------------------------------------------------------------------
// CONSTANTS FOR WEDDINGS, EVENTS, :
//------------------------------------------------------------------------------
const photographerResponsabilitiesWeddings = ({ organization }) => `
  <h3>Photographer’s Responsibilities.</h3>
  <p>
    ${organization.title} (“Photographer”)
    hereby agrees to perform photographic services for Client at the Event specified above in a professional,
     workmanlike manner according to the prevailing standards in the industry (“Services”). Photographer may
     employ one or more assistants. Photographer is not responsible for the impact on the final product of
     any interference caused by guests or other vendors at the Event. Photographer will make every
     effort to obtain, but cannot guarantee delivery of, any specific images requested by client because of
     Photographer’s lack of control over the Event, its participants, weather, and any rules or restrictions
     of the venue or official conducting the Event.
  </p>
  <p>
    a. If Photographer is exposed to (i) unsafe conditions, or (ii) objectionable or illegal acts at the Event,
    Photographer reserves the right to take reasonable action to remedy such a situation, including but
    not limited to leaving the Event. In such event, Photographer shall not be obligated to refund any of
    the fees paid by Client because of such action.
  </p>
  <p>
    b. Exclusivity. ${
      organization.title
    } is to be the only hired photographer at the Event.
  </p>
`;
//------------------------------------------------------------------------------
const retainerAndPaymentWeddings = ({ dueDate }) => `
  <h3>Retainer/Payment.</h3>
  <p>
    A non-refundable retainer (that shall be applied toward the total fee for the Services), 
    as outlined in contract is due upon execution of this agreement, at which time Photographer 
    commits to being available to Client on that date (subject to non-payment, reasonable emergencies 
    and force majeure events).Final payment of the balance due for the Services shall
    be made no later than ${dueDate}. In the event that Client fails to remit payment
    as specified, Photographer shall have the right to immediately terminate this Agreement with no
    further obligation to refund money (including the aforementioned retainer), or to attend the Event.
  </p>
`;
//------------------------------------------------------------------------------
const copyrightWeddings = () => `
  <h3>Copyright.</h3>
  <p>
    All photographs taken by at the Event,
    in whatever form, are copyright protected.
    Any copying, scanning, reprinting, duplicating,
    or altering of the photographs taken by Photographer,
    without Photographer’s express written permission is a
    violation of federal copyright law. The photographs taken
    by Photographer are Photographer’s sole property unless
    purchased by Client.
  </p>
`;
//------------------------------------------------------------------------------
const termsWeddings = () => `
  <h3>Terms.</h3>
  <p>
    The terms of this Agreement shall commence upon the
    execution of this Agreement, and shall terminate upon
    Photographer’s delivery of the final product (Album or Images)
    to the Client, unless terminated earlier as provided herein.
  </p>
`;
//------------------------------------------------------------------------------
const eventChangesCancelationWedding = ({ organization }) => `
  <h3>Event Changes/Cancellation.</h3>
  <p>
    Upon execution of this contract, ${
      organization.title
    } reserves the event date solely for contracting party
    and will not take on any other inquiring events for the same day. As such, if the date of the Event changes,
    then Photographer shall be entitled to 75% of retainer as liquidated damages for having to reschedule the event.
    The remainder of the retainer shall be applied toward the new date, but Client shall be responsible for making
    up the deficiency retained as liquidated damages. If Event becomes cancelled, Photographer entitled to 100% of retainer.
  </p>
`;
//------------------------------------------------------------------------------
const deliveryDateWedding = () => `
  <h3>Delivery Date.</h3>
  <p>
    The final images shall be available in online
    viewing/ordering gallery no later than 6 weeks from
    the event date.
  </p>
`;
//------------------------------------------------------------------------------
const modelReleaseWedding = () => `
  <h3>Model Release.</h3>
  <p>
    Client agrees that Photographer may use images of Client
    from any portion of the Work for display, publication,
    or other promotional uses without payment of additional
    ompensation to Client or Client’s agents. Client’s guests
    at the Event shall be deemed to have consented to the use
    of their name, image, or likeness by Client or Photographer
    for the duration of the Event, and Client shall indemnify
     and defend Photographer from and against any claims
    that any of Client’s guests may assert against Photographer
    arising from, or related to, the use of any name, image,
    or likeness of Client’s guests by Photographer.
  </p>
`;
//------------------------------------------------------------------------------
const forceMajeurWedding = () => `
  <h3>Force Majeure.</h3>
  <p>
     If Photographer is unable to attend Event due to fire,
     flood, casualty, strike, civil disturbance, war,
     terrorism, Photographer’s sickness, or other acts of
     God beyond the parties’ control, then Photographer
     shall return all money paid by Client (including
     any retainer), and this agreement shall immediately terminate.
  </p>
`;
//------------------------------------------------------------------------------
const jurisdictionWedding = ({ organization }) => `
  <h3>Jurisdiction.</h3>
  <p>
    The state and federal courts serving this county ${organization.state &&
      `in ${organization.state}`} shall have
    exclusive jurisdiction over disputes arising from this
    Agreement, and both parties hereto consent to the
    jurisdiction of such courts.
  </p>
`;
//------------------------------------------------------------------------------
const attorneyFeesWedding = () => `
  <h3>Attorney’s Fees.</h3>
  <p>
    The prevailing party in any litigation or dispute
    involving this Agreement, or the Services
    performed thereunder, shall be entitled to
    recover reasonable attorney’s fees, costs,
    and expenses arising from such litigation or
    dispute from non-prevailing party.
  </p>
`;
//------------------------------------------------------------------------------
const indemnificationWedding = () => `
  <h3>Indemnification.</h3>
  <p>
    Client hereby acknowledges that Photographer may
    be limited by the guidelines or rules of the official
    performing the ceremony or the venue, and to hold Photographer
    harmless for the impact such restrictions may have on the final product.
  </p>
`;
//------------------------------------------------------------------------------
const limitationOfLiabilityWedding = () => `
  <h3>LIMITATION OF LIABILITY.</h3>
  <p>
    PHOTOGRAPHER’S ENTIRE LIABILITY FOR ANY CLAIM, LOSS, DAMAGE,
    OR INJURY ARISING UNDER OR RELATING TO THIS AGREEMENT
    IS LIMITED TO THE FEES PAID BY CLIENT FOR THE SERVICES.
    IN NO EVENT SHALL PHOTOGRAPHER BE LIABLE FOR SPECIAL,
    INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, EVEN IF
    CLIENT INFORMS PHOTOGRAPHER OF CIRCUMSTANCES THAT WOULD
    GIVE RISE TO SUCH DAMAGES.
  </p>
`;
//------------------------------------------------------------------------------
const eventMealsWedding = () => `
  <h3>Event Meals.</h3>
  <p>
    Client shall arrange with the caterer for meals to be provided to Photographers.
  </p>
`;
//------------------------------------------------------------------------------
const choiceOfLawWedding = () => `
  <h3>Choice of Law.</h3>
  <p>
    This Agreement shall be governed by the laws of the State of California,
    notwithstanding its conflicts of laws provisions.
  </p>
`;
//------------------------------------------------------------------------------
const waiverMiscellaneousWedding = () => `
  <h3>Waiver/Miscellaneous.</h3>
  <p>
    This Agreement represents the complete and entire agreement of the
    parties with respect to the subject matter herein, notwithstanding any oral or written representations to the contrary made before, during, or after its execution. Any amendments to this Agreement shall only be effective if made in writing that is executed by both parties hereto.
  </p>
`;
//------------------------------------------------------------------------------
const protectionOfDeliverablesRetentionOfFilesWedding = () => `
  <h3>Protection of Deliverables/Retention of Files.</h3>
  <p>
    Photographer shall take all reasonable steps to
    protect the images that are recorded at the Event until
    such time as the final images or album are delivered
    to Client. Once the final images or album has been
    delivered, Photographer shall have no further
    obligation to preserve the images of the Event,
    regardless of the form of media in which they are stored.
  </p>
`;
//------------------------------------------------------------------------------
const eventScheduleWedding = ({ organization }) => `
  <h3>Event Schedule.</h3>
  <p>
    The client agrees to confirm the schedule one-week prior to the event. Notification of any changes in schedule or location must be
    made in a timely manner and confirmation of receipt must be obtained by ${
      organization.title
    }.
  </p>
`;
//------------------------------------------------------------------------------
// TEMPLATES
//------------------------------------------------------------------------------
TextEditorHelpers.getWeddingTermsHTML = options => {
  const TIMEZONE = timezone.tz.guess() || "America/New_York"; // guess users time zone
  const firstParagraph = getFirstParagraph(options);
  const { finalPaymentDueDate, organization } = options;
  const dueDate = finalPaymentDueDate
    ? timezone(finalPaymentDueDate)
        .tz(TIMEZONE)
        .format("dddd, MMMM D YYYY")
    : "";

  return `
    <div>
      ${firstParagraph}
      ${photographerResponsabilitiesWeddings({ organization })}
      ${retainerAndPaymentWeddings({ dueDate })}
      ${copyrightWeddings()}
      ${termsWeddings()}
      ${eventChangesCancelationWedding({ organization })}
      ${deliveryDateWedding()}
      ${modelReleaseWedding()}
      ${forceMajeurWedding()}
      ${jurisdictionWedding({ organization })}
      ${attorneyFeesWedding()}
      ${indemnificationWedding()}
      ${limitationOfLiabilityWedding()}
      ${eventMealsWedding()}
      ${choiceOfLawWedding()}
      ${waiverMiscellaneousWedding()}
      ${protectionOfDeliverablesRetentionOfFilesWedding()}
    </div>
  `;
};
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------

export default TextEditorHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/TextEditorHelpers/index.js